import React, {useState} from "react";
import { useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import FormBranch from "../../../components/common/forms/FormBranch";
// import BackButton from "../../../components/common/backbutton/BackButton";
import FormPayment from "../../../components/common/forms/FormPayment";
// import BackButton from "../../../../components/common/backbutton/BackButton";
// import FormPayment from "../../../../components/common/forms/FormPayment";
import api from "../../../api/api";
import { toast } from 'react-toastify';
import NewFormPayment from '../../../components/common/forms/NewFormPayment';
import FormButtom from '../../../components/common/forms/FormButtom';

import { useSelector } from "react-redux";
import AdminSearchCustomer from "../common/AdminSearchCustomer";

const OthersDynamicServices = () => {
  const { register, handleSubmit } = useForm();
  const { state } = useLocation();
  const { slug } = useParams();
  const { user } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);

  const onSubmit = (data) => {
    data.type = state.Codename;

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/others/", data)
      .then((response) => {
        // console.log(response.data)
        toast.success("Data Registered Successfully");
      })
      .catch((error) => {
        // console.log(error)
        toast.error("Data Registration Failed");
      });
  };
  // console.log(slug);





  return (
    <>
      <div>
        <div className="">
          <form onSubmit={handleSubmit(onSubmit)} className="px-10 lg:!px-14">
            <h1 className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
              {/* {slug.split("-")[0]} */}
              {/* Dynamic Services */}
              {/* {state.englishText} */}
              {state.ServiceName}
            </h1>

            <div className="mt-3">
              {(user?.user_type === "ST" || user?.user_type === "AD") && (
                <AdminSearchCustomer setUserId={setUserId} />
              )}
            </div>

            {/* company name details */}
            <div className="mt-5">
              {/* <BackButton/> */}

              <div className="flex justify-between">
                <p className=" text-lg ">
                  क्यालेन्डर छपाईको लागि निम्नुसारको विवरण भरेर अर्डर गर्नुहोस ।
                </p>
                <p className="text-primary-red flex">
                  Firm No.
                  <p className=" text-primary-blue"> 1234</p>
                </p>
              </div>

              <div className="mt-4">
                <div className="flex-col flex md:flex-row flex-wrap">
                  <div className="flex flex-1 flex-wrap  border items-center m-0 px-2 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      काम गर्ने कम्पनी वा ब्यवसायको नाम :
                    </label>
                    <input
                      type="text"
                      placeholder="e.g भरतपुर ट्रेदिङ् प्रा.ली."
                      name="company_name"
                      className=" text-primary-blue w-[60%] m-0  py-3 px-3 outline-none"
                      {...register("business_name", { required: false, })}
                    />
                  </div>
                  <div className="flex flex-1 flex-wrap w-fit  border md:border-l-0 px-2 items-center border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      कम्पनीको ठेगाना :
                    </label>
                    <input
                      type="text"
                      placeholder="e.g भरतपुर - ११ , चितवन"
                      name="address"
                      {...register("business_address", { required: false, })}
                      className=" text-primary-blue w-[60%] flex-shrink-0 m-0  py-3 px-3 outline-none"
                    />
                  </div>
                </div>
                <div className="flex-col flex md:flex-row">
                  <div className="flex flex-1 flex-wrap border items-center border-t-0 px-2 border-primary-blue">
                    <label className="border-primary-blue  flex-shrink-0 text-primary-red  text-lg font-bold">
                      दर्ता नं. :{" "}
                    </label>
                    <input
                      type="number"
                      placeholder="e.g ६०७६/५३४४३/३५"
                      {...register("reg_number", { required: false, })}
                      className=" text-primary-blue w-[30%]  m-0  py-3 px-2 outline-none"
                    />
                  </div>
                  <div className="flex flex-1  border border-l-0 px-2 items-center border-t-0 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      पान नं. :
                    </label>
                    <input
                      type="number"
                      placeholder="e.g १२३४५६६६५५"
                      {...register("pan_number", { required: false, })}
                      className=" text-primary-blue w-[80%] m-0  py-3 px-3 outline-none"
                    />
                  </div>
                  <div className="flex flex-1 flex-wrap  border border-l-0 px-2 items-center border-t-0 border-primary-blue">
                    <label className="border-primary-blue flex-shrink-0 border-l-0 text-primary-red  text-lg font-bold">
                      सम्पर्क नं. :
                    </label>
                    <input
                      type="number"
                      placeholder="e.g ९८००००००००"
                      name="phone_nummber"
                      {...register("contact_number", { required: false, })}
                      className=" text-primary-blue  m-0 px-3  outline-none"
                    />
                  </div>
                </div>
              </div>

              <div className="border-2  rounded-[2rem] align-middle border-red-600 mt-3">
                <p className="text-primary-blue mt-0 text-base font-medium leading-10 md:!text-lg text-center">
                  Service Fees Shown above are not inlcude any Goverment
                  Charges,VAT,Taxes,Fines,Penalties and Incidental costs
                </p>
              </div>
            </div>

            {/* company objective */}
            <div className="mt-5">
              <p className="text-primary-blue font-Calistoga ">
              2. Main Objectives  <span className="font-Laila"> अन्य केहि बिवरण दिनु पर्ने भएका यहाँ लेख्नुहोस् ।</span>
              </p>
              {/* text area */}
              <div className="mt-3">
                <textarea
                  name=""
                  className="border-primary-blue outline-none text-primary-blue w-full border-2 p-3"
                  id=""
                  cols={30}
                  rows={10}
                  defaultValue={""}
                  {...register("remarks", { required: false, })}
                />
              </div>
            </div>
            <div className="text-primary-blue font-Calistoga text-lg underline my-5">
              3. Working Branch
              <span className="text-primary-blue font-Laila underline text-base  mx-2">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
                नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>

            <FormBranch register={register} name="working_branch_code" />
            <FormButtom />
            {/* sumbit modal */}

            <NewFormPayment
              register={register}
              handleSubmit={handleSubmit}
              handleClick={onSubmit}
            />
          </form>
        </div>
      </div>
    </>
  )
}

export default OthersDynamicServices;
